import { useEffect } from 'react';

let mounts = 0;

// Set as a class on <body> rather than passed to the container: `ToastContainer` is mounted at the
// app root, above the router, so the singing route has no way to reach it through React.
export default function useToastsBesideLyrics(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    document.body.classList.add('toasts-beside-lyrics');
    mounts++;

    return () => {
      mounts--;

      if (mounts === 0) {
        document.body.classList.remove('toasts-beside-lyrics');
      }
    };
  }, [enabled]);
}
